import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Whether the screen is too narrow for a layout that assumes a desktop's width.
 *
 * One definition, because two would drift: the header already switched its nav to a drawer
 * at `md` before this existed, and a page that swapped its table for cards at some other
 * width would put a tablet in two minds about what kind of device it is.
 *
 * `md` (900px) rather than `sm` (600px) because that is where the widest table actually
 * stops fitting, not where a phone stops being a phone. The clinic list needs 762px of
 * columns inside a container that is the viewport less 48, so it wants 810px before it can
 * be drawn as a table at all; the patient list wants 733. Below `md` every one of them is
 * either scrolling sideways or squeezed, which is what the card lists exist to avoid. An
 * iPad in portrait therefore reads as compact -- and gets cards it can tap rather than a
 * table it would have to drag.
 *
 * Under Jest this is `false`: `setupTests.ts` stubs `matchMedia` as never matching, so a
 * component test renders the wide branch unless it says otherwise.
 */
export const useIsCompact = (): boolean => {
    const theme = useTheme();

    return useMediaQuery(theme.breakpoints.down('md'));
};
